/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type FlightCellStatus = typeof FlightCellStatus[keyof typeof FlightCellStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FlightCellStatus = {
  Scheduled: 'Scheduled',
  Missing: 'Missing',
  WithoutTime: 'WithoutTime',
} as const;
